/**
 *
 * Asynchronously loads the component for Patient
 *
 */

import loadable from "utils/loadable";

export default loadable(() => import("./index"));
